import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import type { StoreActions, Store } from 'components/move-list/store/types';
import { MoveList } from 'chessboard/model/move-list/types';
import { CONTEXT_MENU_ACTION_NAMES } from '../config/context-menu-action-names';

/**
 * Create HideAllAnnotations action
 */
export function createInsertContinuationAction(
  _store: Store,
  _storeActions: StoreActions,
): ContextMenu.Action {
  return {
    getDisplayName: () => MoveList.Translation.Actions.InsertContinuation,
    action: CONTEXT_MENU_ACTION_NAMES.InsertContinuation,
    isVisible,
    handler,
  };

  /**
   * Only show this when the item is the last move on the line.
   */
  function isVisible({ game, node }: ContextMenu.ActionHandlerContext) {
    const lines = game.getRawLines();

    return node.ids.move === lines[node.ids.line].length - 1;
  }

  /**
   * handler to hide annotations
   */
  function handler({ game }: ContextMenu.ActionHandlerContext): void {
    game.createContinuation();
  }
}
